var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.$style.Wrapper, ( _obj = {}, _obj[_vm.$style.Vertical] = _vm.vertical, _obj )],style:(_vm.getstyle)})}
var staticRenderFns = []

export { render, staticRenderFns }